document.addEventListener("DOMContentLoaded", function () {
  const scopingClassName = 'product-landing-section';

  // Elems.
  const ctaBtn = document.querySelector(
    `.${scopingClassName} .add-to-cart-container .cta-btn`
  );
  const ctaBtnDot = document.querySelector(
    ".add-to-cart-container .cta-under .product-avail-dot"
  );
  const ctaBtnText = document.querySelector(
    ".add-to-cart-container .cta-under .product-avail-text"
  );
  const notifyMeBtn = document.querySelector(
    ".add-to-cart-container .sub-container2 .add-to-cart-notify"
  );
  const addToCardWhatsappBtn = document.querySelector(
    ".shop-on-call-icons"
  );
  const addToCardWhatsappBtnMobile = document.querySelector(
    ".shop-on-call-icons-mobile"
  );
  
  const ctaBtnLinkText = document.querySelector(
    ".add-to-cart-container .sub-container2 .whatsapp-text"
  );
  const eddElem = document.querySelector(
    ".edd-or-preorder-container .edd-container"
  );
  const preorderBannerElem = document.querySelector(
    ".edd-or-preorder-container pre-order-banner"
  );
  const modulusCtaBtn = document.querySelectorAll(
    ".modulus-cta"
  );

  /* Offer carausel */
  const  offer_price =  document.querySelector(
    ".offer-carousel .offer-carousel-container .card .body.offer span"
  )

  /** Color swatches functionality */
  const colorSwatches = document.querySelectorAll(
    ".product-landing-section .color-container .color-swatch"
  );

  var selectedSwatch = document.querySelector(
    ".product-landing-section .color-container.selected .color-swatch"
  );

  var selectedSwatchParentColorContainer = selectedSwatch.parentElement;
  var selectedVariantId = selectedSwatchParentColorContainer.dataset.variantId;

  selectedSwatch.classList.add("selected");

  colorSwatchClickHandler = (e) => {
    const clickedSwatch = e.target;

    // Reset existing selection if any.
    if (selectedSwatch) {
      selectedSwatch.classList.remove("selected");
    }

    // Select clicked swatch.
    clickedSwatch.classList.add("selected");

    // Track selection.
    selectedSwatch = clickedSwatch;
    selectedSwatchParentColorContainer = selectedSwatch.parentElement;
    selectedVariantId = selectedSwatchParentColorContainer.dataset.variantId;
    resetProductImageContainersForNewVariant();
    updateCtaBtn();
  };

  colorSwatches.forEach((swatch) => {
    // Add click event listeners on each of them.
    swatch.addEventListener("click", colorSwatchClickHandler);
  });

  // product detail ships today/tomorrow
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  // onload logic for ships today/tomorrow
  // ships today/tomorrow shows when varient is available and is nnot preorder
  if (selectedSwatchParentColorContainer.dataset["variantAvailable"] != "false" && (selectedSwatchParentColorContainer.dataset["variantPreorder"] == "false" || selectedSwatchParentColorContainer.dataset["variantPreorder"] == "")) {
    if (currentHour < 13 || (currentHour === 13 && currentMinutes < 30)) {
      ctaBtnText.innerHTML = "Ships today";
    } else {
      ctaBtnText.innerHTML = "Ships tomorrow";
    }
  }

  /** Product image navigation */
  var selectedImageContainer = document.querySelector(
    ".product-landing-section .product-image-container.selected"
  );

  const landingSectionLeftNavBtns = document.querySelectorAll(
    ".product-landing-section .product-image-container .product-image-pagination-control.left"
  );
  const landingSectionRightNavBtns = document.querySelectorAll(
    ".product-landing-section .product-image-container .product-image-pagination-control.right"
  );
  const allVariantsProductMediaList = document.querySelectorAll(
    ".product-landing-section .product-image-container .media-container"
  );

  // Initialize slide-indicator-dots.
  const productMediaContainers = document.querySelectorAll(
    ".product-landing-section .product-image-container .media-container"
  );
  const numberOfMediaContainers = productMediaContainers.length; // All images.
  const numberOfImageContainers = document.querySelectorAll(
    ".product-landing-section .product-image-container"
  ).length; // No. of variants.
  const numberOfSlideDots = numberOfMediaContainers / numberOfImageContainers; // Images/Dots per each variant.

  const mediaSlideIndicatorDotsContainer = document.querySelector(
    ".product-landing-section .media-slide-indicator-dots-container"
  );

  var activeProductMediaIndex; // By default, first product media will be shown.
  for (let i = 0; i < allVariantsProductMediaList.length; i++) {
    if (allVariantsProductMediaList[i].classList.contains("active")) {
      activeProductMediaIndex = i;
    }
  }

  var activeDotIndex = activeProductMediaIndex % numberOfSlideDots;
  const numOfProductMedia = allVariantsProductMediaList.length; // By default, first product media will be shown.
  allVariantsProductMediaList[0].classList.add("active");

  for (let i = 0; i < numberOfSlideDots; ++i) {
    const mediaSlideIndicatorDot = document.createElement("DIV");
    mediaSlideIndicatorDot.classList.add("slide-dot");
    if (activeDotIndex == i) {
      mediaSlideIndicatorDot.classList.add("active");
    }
    mediaSlideIndicatorDotsContainer.appendChild(mediaSlideIndicatorDot);
  }

  const listOfMediaSlideIndicatorDots = document.querySelectorAll(
    ".product-landing-section .media-slide-indicator-dots-container .slide-dot"
  );

  // TODO: Add event listeners for product media navigation controls.
  leftNavHandler = () => {
    activeDotIndex = activeProductMediaIndex % numberOfSlideDots;
    allVariantsProductMediaList[
      activeProductMediaIndex // global.
    ].classList.remove("active");
    listOfMediaSlideIndicatorDots[activeDotIndex].classList.remove("active");

    // Cycling/looping back to first or last image/dot happens based on activeDotIndex.
    if (activeDotIndex == 0) {
      activeProductMediaIndex =
        activeProductMediaIndex + (numberOfSlideDots - 1); // Reset to last Product Media. Looping.
      activeDotIndex = numberOfSlideDots - 1; // Jump to the last dot.
    } else {
      --activeProductMediaIndex;
      --activeDotIndex;
    }
    allVariantsProductMediaList[activeProductMediaIndex].classList.add(
      "active"
    );
    // local index of dots.
    listOfMediaSlideIndicatorDots[activeDotIndex].classList.add("active");
  };

  rightNavHandler = () => {
    activeDotIndex = activeProductMediaIndex % numberOfSlideDots;
    allVariantsProductMediaList[
      activeProductMediaIndex // global.
    ].classList.remove("active");
    listOfMediaSlideIndicatorDots[activeDotIndex].classList.remove("active");
    if (activeDotIndex == numberOfSlideDots - 1) {
      activeProductMediaIndex =
        activeProductMediaIndex - (numberOfSlideDots - 1); // Reset to last Product Media. Looping.
      activeDotIndex = activeDotIndex - (numberOfSlideDots - 1); // Jump to the last dot.
    } else {
      ++activeProductMediaIndex;
      ++activeDotIndex;
    }
    allVariantsProductMediaList[activeProductMediaIndex].classList.add(
      "active"
    );
    // local index of dots.
    listOfMediaSlideIndicatorDots[activeDotIndex].classList.add("active");
  };

  landingSectionLeftNavBtns.forEach((btn) =>
    btn.addEventListener("click", leftNavHandler)
  );
  landingSectionRightNavBtns.forEach((btn) => {
    btn.addEventListener("click", rightNavHandler);
  });
  document
    .querySelectorAll(".product-landing-section .product-image-container")
    .forEach((imageContainer) => {
      imageContainer.addEventListener("swiped-right", leftNavHandler);
    });
  document
    .querySelectorAll(".product-landing-section .product-image-container")
    .forEach((imageContainer) => {
      imageContainer.addEventListener("swiped-left", rightNavHandler);
    });

  function resetProductImageContainersForNewVariant() {
    selectedImageContainer.classList.remove("selected");
    selectedImageContainer
      .querySelector(".media-container.active")
      .classList.remove("active");

    selectedImageContainer = document.querySelector(
      `.product-landing-section .product-image-container[data-variant-id="${selectedVariantId}"]`
    );
    selectedImageContainer.classList.add("selected");
    selectedImageContainer
      .querySelectorAll(".media-container")
      [activeDotIndex].classList.add("active");

    for (let i = 0; i < allVariantsProductMediaList.length; i++) {
      if (allVariantsProductMediaList[i].classList.contains("active")) {
        activeProductMediaIndex = i;
      }
    }
  }

  function resetCTA(){
    ctaBtn.classList.remove("sold-out");
    ctaBtn.style.pointerEvents = "unset";
    ctaBtn.textContent = "";
    ctaBtnDot.classList.remove("dot-red");
    ctaBtnText.textContent = "";
    ctaBtnLinkText.textContent = "";
    notifyMeBtn.classList.add("hide");
    addToCardWhatsappBtn.classList.add("hide");
    addToCardWhatsappBtnMobile.classList.add("hide");    
  }

  function addToCardCTA(){
    ctaBtn.textContent = "Add to cart";
    if(currentHour < 13 || (currentHour === 13 && currentMinutes < 30))ctaBtnText.textContent = "Ships today";
    else ctaBtnText.textContent = "Ships tomorrow";
    ctaBtnLinkText.textContent = "Shop on call";
    addToCardWhatsappBtnMobile.classList.remove("hide");
    addToCardWhatsappBtn.classList.remove("hide");
    // Update EDD-or-Preorder container.
    preorderBannerElem.classList.add("hide");
    eddElem.classList.remove("hide");
  }

  function preOrderCTA(){
    ctaBtn.textContent = "Pre-order*";
    ctaBtnDot.classList.add("dot-red");
    ctaBtnText.textContent = "Shipping starts on 10 April 2025";
    ctaBtnLinkText.textContent = "";
    const offerPrice = selectedSwatchParentColorContainer.dataset["variantPreorderOfferPrice"];
    const salePrice = selectedSwatchParentColorContainer.dataset["variantPreorderCompareAtSalePrice"];
    preorderBannerElem.setAttribute('price', offerPrice);
    preorderBannerElem.setAttribute('compare-at-sale-price', salePrice);
    preorderBannerElem.classList.remove("hide");
    eddElem.classList.add("hide");
  }

  function notifyMeCTA(){
    ctaBtn.classList.add("sold-out");
    ctaBtn.style.pointerEvents = "none";
    ctaBtn.textContent = "Add to cart";
    ctaBtnDot.classList.add("dot-red");
    ctaBtnText.textContent = "Sold out";
    ctaBtnLinkText.textContent = "Notify me";
    notifyMeBtn.classList.remove("hide");
    // Update EDD-or-Preorder container.
    preorderBannerElem.classList.add("hide");
    eddElem.classList.remove("hide");
  }

  function updateCtaBtn(){
    // Update CTA btn, based on variant availability.
    const available = selectedSwatchParentColorContainer.dataset["variantAvailable"];
    const preOrder = selectedSwatchParentColorContainer.dataset["variantPreorder"];
    resetCTA();
    if (available === "false") {
      notifyMeCTA();
    } else if(preOrder == "true"){
      preOrderCTA();
    }else{
      addToCardCTA();
    }
  }

  // const ctaBtnText = document.querySelector(
  //   ".add-to-cart-container .cta-under .product-avail-text"
  // );
  // const ctaBtnLink = document.querySelector(
  //   ".add-to-cart-container .sub-container2 a"
  // );
  // const ctaBtnImg = document.querySelectorAll(
  //   ".add-to-cart-container .sub-container2 a img"
  // );
  // const ctaBtnLinkText = document.querySelector(
  //   ".add-to-cart-container .sub-container2 .whatsapp-text"
  // );

  /* Initialize Explore indicator functionality. */
  // It should hide itself is user scrolls certain pixels.
  if (!isMobileDevice) {
    const exploreIndicatorElem = document.getElementById("explore-indicator"); // Replace with your element's ID
    const bentoLayout = document.getElementById("bento-layout"); // Replace with your element's ID
    const scrollThreshold = 200; // Adjust the scroll threshold as needed

    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition >= scrollThreshold) {
        exploreIndicatorElem.style.display = "none";
      } else {
        exploreIndicatorElem.style.display = "flex";
      }
    });
    exploreIndicatorElem.addEventListener("click", () => {
      bentoLayout.scrollIntoView({ behavior: "smooth" });
      exploreIndicatorElem.style.display = "none";
    });
  }

  /** Add product to cart */
  const addToCartBtn = document.querySelector(
    ".add-to-cart-container .cta-btn"
  );
  addToCartBtn.addEventListener("click", addVariantToCart);

  async function addVariantToCart(e) {
    const preOrder = selectedSwatchParentColorContainer.dataset["variantPreorder"]
    if(preOrder == "true")return;   
    console.log('product chair local addVariantToCart: variantId from button clicked -> ' + e.target.dataset["variantId"]);
    console.log(`selectedVariantId: ${selectedVariantId}`);

    const cartItems = await Shopify.addVariantToCart(selectedVariantId);
    console.log(`updated cart items: ${cartItems}`);
    // const event = new CustomEvent('update-badge');
    // e.target.dispatchEvent(event);
    Shopify.eventBus.emit('add-variant-to-cart');
    // TODO: Update all places where Cart info is shown.
  }

  // modulus
  async function isModulusAvailable(){
    if(modulusCtaBtn[0].classList.contains("disabled"))return;
    const url = 'https://pkhwnphzllnyptnvqxsi.supabase.co/functions/v1/agent-status';
    const token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBraHducGh6bGxueXB0bnZxeHNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcwNDk4NTksImV4cCI6MjA1MjYyNTg1OX0.0GW5GLqzeiMtL6tUpn-khkRSRJBH1rp6yVZn4nqD2CY';
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': token,
            },
            body: JSON.stringify({ "name": 'Functions' })
        });
        
        const data = await response.json();
        if(data.is_available){
          modulusCtaBtn.forEach((btn) => {
            btn.href = "https://modulus-client-app-web.vercel.app/"
            btn.target = "_blank";
          });
          return;
        }
    } catch (error) {
        console.error('Error:', error);
    }
    modulusCtaBtn.forEach((btn) => {
      btn.classList.add("disabled");
    });
  }

  isModulusAvailable();
  updateCtaBtn();
});
